'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LogUploader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _LogUploader = require('./LogUploader.less');

var _LogUploader2 = _interopRequireDefault(_LogUploader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogUploader = exports.LogUploader = function (_Component) {
	_inherits(LogUploader, _Component);

	function LogUploader() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, LogUploader);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LogUploader.__proto__ || Object.getPrototypeOf(LogUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			message: 'Load log file...'
		}, _this.onDrop = function (files) {
			var file = files[0];
			var reader = new FileReader();
			reader.onload = function (e) {
				var content = e.target.result.trim();
				if (!_this.isLog(content)) {
					_this.setState({ message: 'Invalid log file' });
					return;
				}
				_this.props.onLogFile(content);
			};
			reader.readAsText(file);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(LogUploader, [{
		key: 'isLog',
		value: function isLog(content) {
			return content[0] === '{' && content[content.length - 1] === '}';
		}
	}, {
		key: 'render',
		value: function render() {
			var dropStyle = {
				padding: '10px 15px',
				cursor: 'pointer',
				opacity: .57
			};
			return React.createElement(
				_reactDropzone2.default,
				{ multiple: false, accept: 'text/*', style: dropStyle,
					onDrop: this.onDrop },
				this.state.message
			);
		}
	}]);

	return LogUploader;
}(_react.Component);


//////////////////
// WEBPACK FOOTER
// ./js/Components/LogUploader.js
// module id = 647
// module chunks = 0